/* 周瑜傳・第 3 章下半、第 4 章：南郡・江陵（建安十三年～十五年，208–210）
 * 長江在南邊。東邊是江陵城（西門、南門），西邊是渡到北岸的吳營：中軍大帳四周有五處營落，周瑜帶傷巡營要一處處走到。
 * 第 4 章江陵已經是吳的：城裡的倉、庫，城南的船場；船從船場順江往東，到巴丘。 */
export const CITY = { x: 7300, y: 2100, hw: 640, hh: 440 };
const T = 34, G = 120, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATES = { w: [Wx, CITY.y], s: [CITY.x, S] };
export const CAMP = [2200, 2300], TENT = [2200, 2260];
export const STATIONS = [['前營', 3050, 2300], ['北營', 2250, 1550], ['南營', 2350, 3050], ['後營', 1350, 2250], ['水營', 3000, 3250]];
export const FIELD = [4700, 2250], LINE = [5700, 2250]; // 兩軍之間的平野、曹仁列陣的地方
export const DOCK = [CITY.x, 3500], BAQIU = [9000, 4200];
export const PREP = { fu: [CITY.x, CITY.y - 40], cang: [CITY.x + 380, CITY.y - 200], ku: [CITY.x - 380, CITY.y - 200], ying: [5900, 2900], dock: DOCK };
export default {
  id: 'zhouyu_nanjun', name: '南郡', W: 9200, H: 4800, seed: 2090,
  bases: [CAMP, [CITY.x, CITY.y]],
  walls: [
    [CITY.x, N, CITY.hw + T, T], [E, CITY.y, T, CITY.hh],
    [(CITY.x - G + Wx) / 2, S, (CITY.x - G - Wx) / 2 + T, T], [(CITY.x + G + E) / 2, S, (E - CITY.x - G) / 2 + T, T],
    [Wx, (N + CITY.y - G) / 2, T, (CITY.y - G - N) / 2], [Wx, (S + CITY.y + G) / 2, T, (S - CITY.y - G) / 2],
  ],
  rivers: [{ pts: [[-100, 4250], [3000, 4180], [6000, 4250], [9300, 4200]], hw: 520, fords: [] }],
  roads: [
    { pts: [[400, 2250], CAMP, [3200, 2300], FIELD, LINE, GATES.w, [CITY.x, CITY.y]], w: 150 },
    { pts: [[CITY.x, CITY.y], GATES.s, [CITY.x, 3450]], w: 120 },
    { pts: [CAMP, [2800, 3100], [3000, 3450]], w: 110 },
  ],
  rocks: [[4300, 1100, 380, 180], [5200, 3300, 360, 170], [1000, 1100, 320, 160], [8600, 1000, 300, 150], [3700, 700, 300, 150]],
  woods: 0.35,
  sight: 0.8,
  clearings: [[CAMP[0], CAMP[1], 1000], [CITY.x, CITY.y, 800], [FIELD[0], FIELD[1], 700], [LINE[0], LINE[1], 500], [DOCK[0], DOCK[1] - 100, 300], [PREP.ying[0], PREP.ying[1], 300]],
  tents: [
    { x: TENT[0], y: TENT[1], n: 6, r: 260, chief: true, col: '#b8433a', flag: '周' },
    { x: PREP.ying[0], y: PREP.ying[1], n: 3, r: 220, col: '#b8433a', flag: '吳' },
  ],
  grass: [[4200, 1700, 240, 100], [4300, 2900, 240, 100]],
};
